interface IMinisiteConstant {
  DEFAULT_THEME: {
    PRIMARY_COLOR: string;
    SECONDARY_COLOR: string;
  };
  OVERWRITE_META_TAG: {
    HOME_PAGE_TITLE: string;
    HOME_PAGE_DESCRIPTION: string;
  };
}

const MINISITE: IMinisiteConstant = {
  DEFAULT_THEME: {
    PRIMARY_COLOR: '#00B6F0',
    SECONDARY_COLOR: '#8AC65A',
  },
  OVERWRITE_META_TAG: {
    HOME_PAGE_TITLE: 'Home Page Title',
    HOME_PAGE_DESCRIPTION: 'Home Page Description',
  },
};

export default MINISITE;
